import React from 'react';
import { useFeatureFlags } from '../hooks/useFeatureFlags';
import { DisabledModule } from './DisabledModule';

export function FeatureGuard({ featureKey, moduleName, children }) {
  const { isEnabled, getVisibility, loading } = useFeatureFlags();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  const visibility = getVisibility(featureKey);

  if (isEnabled(featureKey)) {
    return children;
  }

  if (visibility === 'hidden') {
    return (
      <DisabledModule
        moduleName={moduleName}
        description="This feature is not available."
      />
    );
  }

  // coming_soon or any other non-enabled state
  return (
    <DisabledModule
      moduleName={moduleName}
      description={`The ${moduleName} module is not yet enabled for your store. Contact support to request access.`}
    />
  );
}
